import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "../Layout/Layout";
import Dashboard from "../Layout/Dashboard";
import Home from "../Home/Home";
import EngineeringDrawings from "../Engineering-Drawings/EngineeringDrawings";
import LoadAnalysis from "../Load-Analysis/LoadAnalysis";
import Reports from "../Reports/Reports";
import Contact from "../Contact/Contact";
import Login from "../auth/Login";
import SystemAnalysisType from "../System-Analysis/SystemAnalysisType";
import Calendar from "../Calendar/Calendar";
import PipeAnalysisType from "../Pipe-Analysis/PipeAnalysisType";
import PsmType from "../PSM/PsmType";
import Facility from "../Layout/Facility";
import ProtectedRoute from "./ProtectedRoute";
import useAutoLogout from "../Custom-Hooks/useAutoLogout";
import DrawingPage from "../shared/DrawingPage";
import UserProfile from "../Layout/UserProfile";
import ForgotPassword from "../auth/ForgotPassword";
import DocStore from "../Docstore/Docstore";
import ProtectedAdminRoute from "./ProtectedAdminRoute";
import AdminRoutes from "./AdminRoutes";
import UserPreference from "../User-Preference/UserPreference";
import UserPreferenceWidgets from "../User-Preference/UserPreferenceWidgets.tsx";
import VerifyEmail from "../User-Management/VerifyEmail.jsx";
import AdminInitiatedPasswordReset from "../User-Management/AdminInitiatedPasswordReset.jsx";
import DashboardRedirect from "../Layout/DashboardRedirect.jsx";
import FacilityManagement from "../Layout/FacilityManagement.jsx";

import OfficeDocsViewer from '../../components/OfficeDocsViewer/OfficeDocsViewer.Layout';

const RoutesConfig = () => {
  useAutoLogout();
  return (
    <Routes>
      {/* Redirect from root path to login */}
      <Route path="/" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password-reset" element={<ForgotPassword />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/admin-initiated-password-reset" element={<AdminInitiatedPasswordReset />} />
      <Route
					path="/docx-viewer/:id"
					element={
							<OfficeDocsViewer />
					}
				/>

      {/* Protected Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/facility" element={<Facility />} />

        <Route element={<Layout />}>
        <Route path="/dashboard" element={<DashboardRedirect />} />
          <Route path="/dashboard/:pageId" element={<Dashboard />}>
            <Route index element={<Home />} />
          </Route>
          <Route
            path="/dashboard/system-analysis"
            element={<SystemAnalysisType />}
          />
          <Route
            path="/dashboard/pipe-analysis"
            element={<PipeAnalysisType />}
          />
          <Route path="/dashboard/psm" element={<PsmType />} />
          <Route path="/dashboard/drawing" element={<DrawingPage />} />
          <Route
            path="/engineering-drawings"
            element={<EngineeringDrawings />}
          />
          <Route path="/load-analysis" element={<LoadAnalysis />} />
          <Route path="/doc-store" element={<DocStore />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/user-profile" element={<UserProfile />} />
          <Route path="/user-preference" element={<UserPreference />} />
          <Route path="/facility-management" element={<FacilityManagement />} />
          <Route
            path="/user-preference/user-preference-widgets"
            element={<UserPreferenceWidgets />}
          />
          <Route element={<ProtectedAdminRoute />}>{AdminRoutes}</Route>
        </Route>
      </Route>
      <Route path="/forgot-password-reset" element={<ForgotPassword />} />

      {/* If no route found */}
      <Route
        path="*"
        element={<h2 className="text-center mt-4">Page Not Found</h2>}
      />
    </Routes>
  );
};

export default RoutesConfig;
